import { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'

export const toastr = {
  erro: function (txt) {
    setTimeout(() => {
      toast.error(txt, {
        "theme": "colored",
        "type": "default",
        "dangerouslyHTMLString": true
      });
    }, 200);
  },
  sucesso: function (txt) {
    setTimeout(() => {
      toast.success(txt, {
        "theme": "colored",
        "type": "default",
        "dangerouslyHTMLString": true
      });
    }, 200);
  },
  alerta: function (txt) {
    setTimeout(() => {
      toast.warning(txt, {
        "theme": "colored",
        "type": "default",
        "dangerouslyHTMLString": true
      });
    }, 200);
  },
  dark: function (txt) {
    setTimeout(() => {
      toast(txt, {
        "theme": "dark",
        "type": "default",
        "dangerouslyHTMLString": true
      });
    }, 200);
  },
}